// extracted by mini-css-extract-plugin
export default {"dialog":"StaffPasswordResetDialog_dialog__GkJDp"};